<template>
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <Card>
                <div class="row mb-4">
                    <h5 class="col-sm-12 col-md-10 text-bold">{{ __('Shipping documents export') }}</h5>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Shipping date') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <DateTimePicker
                                    :placeholder="__('Select date and time')"
                                    @change="formatShippingDate"
                                    format="YYYY-MM-DD HH:mm"
                                    name="shipping_date_date_from"
                                    type="datetime"
                                    v-model="shippingDocument.date"
                                    value-type="datetime"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Status') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    :value="shippingDocumentState()"
                                    disabled
                                    name="shipping_state"
                                ></FormInput>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Carrier') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <Autocomplete
                                    :data="shippingDocument.carrierCustomer.label"
                                    :fetch-callback="$api.autocomplete.shippingDocumentsCarriers"
                                    :placeholder="__('Select carrier')"
                                    :value="shippingDocument.carrierCustomer.label"
                                    @input="(item) => shippingDocument.carrierCustomer = item"
                                    @selected="(item) => shippingDocument.carrierCustomer = item"
                                    name="shipping_carrier"
                                    v-validate="'required'"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Sender') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <Autocomplete
                                    :data="shippingDocument.senderCustomer.label"
                                    :fetch-callback="$api.autocomplete.shippingDocumentsSenders"
                                    :placeholder="__('Select sender')"
                                    :value="shippingDocument.senderCustomer.label"
                                    @input="(item) => shippingDocument.senderCustomer = item"
                                    @selected="(item) => shippingDocument.senderCustomer = item"
                                    name="shipping_document_sender"
                                    v-validate="'required'"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Transport ID number') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    name="shipping_transport_id"
                                    type="text"
                                    v-model="shippingDocument.transport"
                                ></FormInput>
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Recipient') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <Autocomplete
                                    :data="shippingDocument.receiverCustomer.label"
                                    :fetch-callback="$api.autocomplete.shippingDocumentsTransportReveivers"
                                    :placeholder="__('Select recipient')"
                                    :value="shippingDocument.receiverCustomer.label"
                                    @input="(item) => shippingDocument.receiverCustomer = item"
                                    @selected="(item) => shippingDocument.receiverCustomer = item"
                                    name="shipping_receiver"
                                    v-validate="'required'"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Recipient address') }}
                            </div>

                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    name="shipping_receiver_address"
                                    type="text"
                                    v-model="shippingDocument.receiverAddress"
                                    v-validate="'required'"
                                ></FormInput>
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">

                            </div>

                            <div class="col-sm-12 col-md-7">

                            </div>
                        </div>
                    </div>
                </div>

                <ShipmentsForm :shipments="shippingDocument.shipments" shipmentType="shippingDocument"/>
            </Card>
            <br/>
            <div class="row">
                <div class="col-sm-6 col-md-6">
                    <button
                        @click="submitShipping"
                        class="btn btn-sm btn-cyan btn-seperate col-sm-6 col-md-4"
                        v-if="shippingDocument.id"
                    >
                        {{ __('Submit') }}
                    </button>
                </div>

                <div class="col-sm-6 col-md-6 text-right">
                    <RequestButton
                        :on-click="saveShipping"
                        class="btn btn-sm btn-primary btn-seperate col-sm-6 col-md-4"
                    >
                        {{ __('Save') }}
                    </RequestButton>

                    <button
                        @click="cancel"
                        class="btn btn-sm btn-red col-sm-6 col-md-4"
                    >
                        {{ __('Cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import ShippingDocument from '../../models/ShippingDocument'
import RequestButton from '../../plugins/RequestButton'
import { $api } from '../../services/api'
import { __ } from '../../translations/localization'
import ShipmentsForm from '../Releases/ShipmentsForm'

export default {
  name: 'ShippingDocumentHandle',

  components: { ShipmentsForm, RequestButton },

  beforeRouteEnter (to, from, next) {
    if (!to.params.id) {
      next((vm) => {
        vm.$nextTick(() => vm.$validator.reset())
        vm.shippingDocument = new ShippingDocument({})
      })
    } else {
      $api.shipping.item(to.params.id).then((shipping) => {
        next((vm) => {
          vm.shippingDocument = new ShippingDocument(shipping.data)
        })
      })
    }
  },

  created () {
    $api.autocomplete.shippingDocumentsStates().then((res) => {
      this.shippingStates = res.data[0]
    })
  },

  data () {
    return {
      shippingDocument: new ShippingDocument({}),
      shippingStates: []
    }
  },

  methods: {
    formatShippingDate (date) {
      this.shippingDocument.date = moment(date).format('YYYY-MM-DD HH:mm')
      return this.shippingDocument.date
    },

    shippingDocumentState () {
      this.shippingDocument.state.label = this.shippingStates.label
      this.shippingDocument.state.value = this.shippingStates.value
      return this.shippingDocument.state.label
    },

    submitShipping () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          this.$modal.confirm(
            __('Are you sure want to submit this shipping document?'),
            () => {
              return this.$api.shipping.submit(this.shippingDocument.id)
                .then(() => {
                  this.$toaster.success(__('The shipping document was successfully confirmed!'))
                  this.$router.push('/shipping-documents')
                })
            })
        }
      })
    },

    saveShipping () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.shippingDocument.id) {
            return this.$api.shipping.update(this.shippingDocument.id, this.shippingDocument)
              .then(() => {
                this.$toaster.success(__('The shipping document was successfully updated!'))
                this.$router.push('/shipping-documents')
              })
          }

          return this.$api.shipping.create(this.shippingDocument)
            .then(() => {
              this.$toaster.success(__('The shipping document was successfully created!'))
              this.$router.push('/shipping-documents')
            })
        }
      })
    },

    cancel () {
      this.$modal.confirm(
        __('Are you sure want to cancel?'),
        () => {
          this.$router.push('/')
        }
      )
    }
  }
}
</script>
